// @flow
import { reservationStatuses } from "data/reservations/constants"
import { momentFromDateString, fromDateString } from "data/units/date/helpers"
import type { DateString } from "data/units/date/types"
import type { Profile } from "data/user/types"
import type { Reservation } from "./types"

// returning
const isCheckedOut = (r: Reservation) =>
  r.status === reservationStatuses.checked_out

export const isTodayForReturn = (r: Reservation, d: DateString) =>
  isCheckedOut(r) &&
  momentFromDateString(r.end).isSame(fromDateString(d), "day")

export const isLateForReturn = (r: Reservation, d: DateString) =>
  isCheckedOut(r) &&
  momentFromDateString(r.end).isBefore(fromDateString(d), "day")

// picking up
const isConfirmed = (r: Reservation) =>
  r.status === reservationStatuses.confirmed

export const isTodayForPickup = (r: Reservation, d: DateString) =>
  isConfirmed(r) &&
  momentFromDateString(r.start).isSame(fromDateString(d), "day")

export const isLateForPickup = (r: Reservation, d: DateString) =>
  isConfirmed(r) &&
  momentFromDateString(r.start).isBefore(fromDateString(d), "day")

export const STATES = {
  lateForReturn: "Late for return",
  returnToday: "Due for return today",
  lateForPickup: "Late for pickup",
  pickupToday: "Due for pickup today",
}

export const checkSkiPreconditions = (profile: Profile) => {
  if (profile.din) return true

  if (
    !profile.weight ||
    !profile.birthdate ||
    !profile.height ||
    !profile.skierType
  )
    return false

  return true
}



// WEBPACK FOOTER //
// ./src/data/reservations/helpers.js